import { browserVersion, isIOS, isSafari } from "react-device-detect";

const isIOSSafari = isIOS && isSafari;

const isSafari9OrLess = isSafari && parseFloat(browserVersion) <= 9;

export { isIOSSafari, isSafari9OrLess };
